module.exports = __webpack_public_path__ + "static/media/yam-yam-logo-1601363700.70e81747.png";